import api from '../api/api'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

const getSystemFrontendSettings = async (options = {}) => {
    let { lang, force } = options
    if (!lang) lang = cookies.get('i18next')
    let systemFrontendSettings = JSON.stringify(cookies.get('systemFrontendSettings'))
    if (!systemFrontendSettings || force) {
        systemFrontendSettings = JSON.stringify(await api.getSystemFrontendSettings({ lang }))
        cookies.set('systemFrontendSettings', systemFrontendSettings, { path: '/' })
    }
    return JSON.parse(systemFrontendSettings)
}

export default getSystemFrontendSettings


// WEBPACK FOOTER //
// ./src/lib/systemFrontendSettings.js